<template>
	<div class="">
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="pt10 disflex" style="justify-content: center;background:url(static/images/star.png) no-repeat center -70px;max-width:750px;height: 380px;background-size: cover;    align-items: flex-start;">
          <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
        </div>
      </div>
      <div class="disflex por" style="justify-content: space-between;padding:0 20px;margin: 10px 0;z-index: 99;">
        <div class="account-top ar mr10" @click="back()">
          <img width="80" src="static/images/retrun.png">
        </div>
        <div class="account-top ar mr10" @click="getAcount()">
          <img width="80" src="static/images/account-icon2.png" v-if="isShow">
          <img width="80" src="static/images/account-icon.png" v-else>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              search:'',
              isShow:false,
              isActive:'/',
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,

            }
        },
        mounted() {
          if(this.$route.query.url){
            this.isActive = this.$route.query.url
          }else{
            this.isActive = '/'
          }
          if(localStorage.getItem('token')){
            this.isLogin = true
          }
         },
		methods: {
      back(){
      	this.$router.go(-1);
      },
			showMenu(item){
				let that =this;
				this.isActive = item.url;
        this.$router.push({path:item.url,query:{url:item.url}});
			},
			getAcount(){
				let that =this;
			  this.$router.push({path:'/personalInfo'})
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	//this.isShow = false;
      	this.$refs.saveDialog.showMaskFun();
      },
      // 弹框保存
      saveModal (){
        let that =this;

        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/unsub',null,r =>{

            that.$utils.alertText(r.msg,80,3000);
            that.$parent.$parent.loadModal(false);
            if(r.code==1){
              localStorage.removeItem('token')
              this.$router.push({path:'/subscribe',query:{}});
            }else{
              this.$refs.saveDialog.closeMask();
            }

        })
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/header.vue